import { useState } from "react";

const Contact = () => {
    const [success, setSuccess] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSuccess(true);
        e.target.reset();
    };

    return (
        <div>
            {/* Contact Section */}
            <section className="contact-section-two">
                <div className="auto-container">
                    <div className="row clearfix">

                        {/* Left Content */}
                        <div className="text-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="sec-title">
                                    <div className="upper-text">AlphaBlind — Contact Us</div>
                                    <h2>Have a Question? We’d Love to Help.</h2>
                                </div>

                                {success && (
                                    <div
                                        style={{
                                            marginTop: "20px",
                                            padding: "15px",
                                            background: "#e6fffa",
                                            color: "#065f46",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        ✅ Your message has been submitted successfully.
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Form */}
                        <div className="form-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="form-box">
                                    <div className="default-form contact-form">

                                        <form onSubmit={handleSubmit}>
                                            <div className="row clearfix">

                                                <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                    <input
                                                        type="text"
                                                        name="username"
                                                        placeholder="Your Name"
                                                        required
                                                    />
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        placeholder="Email"
                                                        required
                                                    />
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                    <input
                                                        type="text"
                                                        name="phone"
                                                        placeholder="Phone"
                                                        required
                                                    />
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                    <input
                                                        type="text"
                                                        name="subject"
                                                        placeholder="Subject"
                                                        required
                                                    />
                                                </div>

                                                <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                    <textarea
                                                        name="message"
                                                        placeholder="Message"
                                                        required
                                                    ></textarea>
                                                </div>

                                                <div className="form-group col-md-12 col-sm-12">
                                                    <button
                                                        type="submit"
                                                        className="theme-btn btn-style-one"
                                                    >
                                                        <span className="btn-title">
                                                            Send Message
                                                        </span>
                                                    </button>
                                                </div>

                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
